module.exports = __webpack_public_path__ + "media/images/lp_v6_pc_sakiwari-4f52860512cd37be727d24e5db4f2510.webp";